
export function downloadFile(url, fileName, animationSelectors, method = 'GET', formParameters = undefined, requestHeaders = undefined) {
  const animationElement = document.querySelector(animationSelectors);

  animationElement?.classList.remove('hidden');

  const request = new XMLHttpRequest();
  request.open(method, url, true);
  request.timeout = 0;
  request.responseType = "blob";
  request.setRequestHeader("X-CSRF-Token", document.querySelector("input[name=__anti-forgery-token]")?.value);

  if (requestHeaders)
  {
    for (const [key, value] of Object.entries(requestHeaders)) {
      request.setRequestHeader(key, value);
    }
  }

  request.addEventListener("load", () => {
    animationElement?.classList.add('hidden');

    if(request.status === 200 || request.status === 201) {
      downloadHandler(request.response, fileName);
    }
    else {
      alert('Unable to perform download.');
    }
  });

  if(formParameters === undefined)
    request.send();
  else
    request.send(formParameters);
}

function downloadHandler(response, fileName) {
  const url = window.URL.createObjectURL(response);

  if(navigator.msSaveBlob) {
    navigator.msSaveBlob(response, fileName);
  }
  else {
    const linkElement = document.createElement("a");
    linkElement.href = url;
    linkElement.setAttribute("download", fileName);
    document.body.appendChild(linkElement);
    linkElement.click();
    linkElement.remove();
  }
}
